module.exports = __webpack_public_path__ + "static/media/Sanjose.a34969ee.jpg";